<template>
  <div class="ui segment" style="height:100px">
    <div class="ui active inverted dimmer">
      <div class="ui text loader">Loading</div>
    </div>
    <p></p>
  </div>
</template>

<script>
export default {


  activated: function() {


  this.$store.dispatch('logoutUser').then((response) => {

    this.$router.push('login');
  }).catch((error) => {
     this.$router.push('login');
  })



  }

}
</script>



// WEBPACK FOOTER //
// LogoutPage.vue?f5d4e8da